import { AlertTriangle } from "lucide-react"
import { useTranslation } from "react-i18next"

import { Button } from "../ui/button"

export const MainErrorFallback = () => {
  const { t } = useTranslation()

  return (
    <div
      className="flex h-full flex-col items-center justify-center text-center px-4"
      role="alert"
    >
      <div className="text-red-500 mb-4">
        <AlertTriangle size={48} />
      </div>
      <h2 className="text-xl font-semibold text-red-600 mb-2">
        {t("ErrorTitle") || "Ooops, something went wrong!"}
      </h2>
      <p className="text-sm text-gray-500 mb-6 max-w-md">
        {t("ErrorDescription") ||
          "We encountered an error while loading this page. There might be a connection issue, data not found, or system disruption."}
      </p>
      <Button onClick={() => window.location.assign(window.location.origin)}>
        {t("Refresh") || "Refresh"}
      </Button>
    </div>
  )
}
